Accounts = require 'common/lib/accounts'
Auth = require 'db/auth'
AaDomainClaimBannerView = undefined
queueRequire -> AaDomainClaimBannerView = require 'views/header/aa-domain-claim-banner-view'
AccountTransferRequiredBannerView = undefined
queueRequire -> AccountTransferRequiredBannerView = require 'views/header/account-transfer-required-banner-view'
BoardLimitsGracePeriodBannerView = undefined
queueRequire -> BoardLimitsGracePeriodBannerView = require 'views/board-limits/grace-period-banner-view'
BoardsSidebarView = undefined
queueRequire -> BoardsSidebarView = require 'views/boards-sidebar/boards-sidebar-view'
Browser = require 'lib/browser'
BrowserWillBeUnsupportedView = undefined
queueRequire -> BrowserWillBeUnsupportedView = require 'views/header/browser-will-be-unsupported-view'
ConfirmEmailBannerView = undefined
queueRequire -> ConfirmEmailBannerView = require 'views/header/confirm-email-banner-view'
DowngradePeriodBannerView = undefined
queueRequire -> DowngradePeriodBannerView = require 'views/board-limits/downgrade-period-banner-view'
HeaderBackButtonView = undefined
queueRequire -> HeaderBackButtonView = require 'views/header/header-back-button-view'
EnterpriseLicenseBannerView = undefined
queueRequire -> EnterpriseLicenseBannerView = require 'views/header/enterprise-license-banner-view'
HeaderBoardsButtonView = undefined
queueRequire -> HeaderBoardsButtonView = require 'views/header/header-boards-button-view'
HeaderMemberView = undefined
queueRequire -> HeaderMemberView = require 'views/header/header-member-view'
HeaderWoofView = undefined
queueRequire -> HeaderWoofView = require 'views/header/header-woof-view'
InvitedBannerView = undefined
queueRequire -> InvitedBannerView = require 'views/header/invited-banner-view'
LoggedInPublicBoardBannerView = undefined
queueRequire -> LoggedInPublicBoardBannerView = require 'views/header/logged-in-public-board-banner-view'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
NewLocaleBannerView = require 'views/header/new-locale-banner-view'
OverdueBannerView = undefined
queueRequire -> OverdueBannerView = require 'views/header/overdue-banner-view'
PostRender = require 'views/lib/post-render'
PublicBoardBannerView = undefined
queueRequire -> PublicBoardBannerView = require 'views/header/public-board-banner-view'
SearchInputView = undefined
queueRequire -> SearchInputView = require 'views/search/search-input-view'
SidebarState = undefined
queueRequire -> SidebarState = require 'view-models/sidebar-state'
SetPasswordBannerView = undefined
queueRequire -> SetPasswordBannerView = require 'views/header/set-password-banner-view'
track = require 'debug/track'
TwoFactorBackupsBannerView = undefined
queueRequire -> TwoFactorBackupsBannerView = require 'views/header/two-factor-backups-banner-view'
Util = require 'lib/util'
Storage = require 'lib/storage'
_ = require 'underscore'
$ = require 'jquery'
moment = require 'moment'
templates = require 'views/internal/templates'
locales = require('common/data/supported-locales').default
getExperiment = require 'lib/experiments/simple-test'

{ ldclient } = require 'common/lib/ldclient'

needBackupCodes = (member) ->
  twoFactorPrefs = member.getPref('twoFactor')
  twoFactorPrefs?.enabled && twoFactorPrefs.needsNewBackups

getOverdueOrganization = (member) ->
  bcOrgs = member.organizationList.filter (org) ->
    org.isPremium() &&
    org.ownedByMember(member) &&
    !org.paysWithPurchaseOrder()

  for bcOrg in bcOrgs
    paidAccount = bcOrg.get('paidAccount')
    billingDate = new Date(paidAccount.billingDates?[paidAccount.products?[0]])
    bannerName = "OverdueBanner-#{bcOrg.id}-#{billingDate.getTime()}"
    if Accounts.isProblem(paidAccount.standing) &&
        paidAccount.needsCreditCardUpdate &&
        !member.isDismissed(bannerName)
      return bcOrg

showSeatCapBannerForEntity = (member, entity, idEnterprise, maxMembers, available, headerCache, topLevelView) =>
  threshold = Math.min(Math.ceil(maxMembers * 0.05), 20)
  if available <= threshold
    data = {
      displayName: entity.get('displayName'),
      idEnterprise,
      seats: { max: maxMembers, available }
      cid: entity.cid
    }
    $('#header').after(topLevelView(EnterpriseLicenseBannerView, data, modelCache: headerCache).render().el)

    #record that the banner was shown for this user, so we check that we showed it
    member.recordEnterpriseBannerShownFor(idEnterprise)


showSeatCapBanner = (member, headerCache, topLevelView) =>
  # get the enterprises this member is the admin of, if any and hasn't had
  # its banner shown recently
  enterprises = member.enterpriseList.filter (e) ->
    member.isEnterpriseAdminOf(e) &&
    member.shouldShowEnterpriseBannerFor e.id

  # load license data asynchronously and display the banner if needed
  enterprises.forEach (enterprise) ->
    enterprise.loadMaxMembers().then =>
      #record that we checked if we needed to show the banner, so we don't check again right away
      member.recordEnterpriseBannerCheckedFor(enterprise.id)

      # don't try to load the license data if max members is not set.
      # child enterprises do not have max members set, so this also
      # excludes showing the banner for child enterprises
      return unless maxMembers = enterprise.getPref('maxMembers')
      enterprise.loadLicenses().then =>
        available = enterprise.getAvailableLicenses()
        showSeatCapBannerForEntity(member, enterprise, enterprise.id, maxMembers, available, headerCache, topLevelView)

  # find bpco orgs this member is the admin of and hasn't already had
  # its banner shown recently. if there are more than one related bcpo
  # org, only grab one
  bcpoOrgs = _.uniq member.organizationList.models.filter((org) ->
      org.paysWithPurchaseOrder() &&
      org.isBusinessClass() &&
      org.ownedByMember(member) &&
      member.shouldShowEnterpriseBannerFor org.get('idEnterprise')
    ), (org) -> org.get('idEnterprise')

  # load license data asynchronously and display the banner if needed
  bcpoOrgs.forEach (org) ->
    idEnterprise = org.get('idEnterprise')
    org.loadLicenses().then =>
      max = org.get('maximumLicenseCount')
      available = org.get('availableLicenseCount')
      #record that we checked if we needed to show the banner, so we don't check again right away
      member.recordEnterpriseBannerCheckedFor(idEnterprise)
      showSeatCapBannerForEntity(member, org, idEnterprise, max, available, headerCache, topLevelView)

module.exports =
  renderBannerContent: (selector) ->
    me = Auth.me()
    headerCache = ModelCache
    container = $('#banners')

    bannerLocales =
    _.chain(locales)
      .pluck('code')
      .filter((locale) -> locale.indexOf('en') != 0)
      .value()

    # See if we need to display a "your browser is old" message
    if /^(explorer-10|safari-[678])/.test(Browser.browserVersionStr) || ldclient.variation('web.drop_ie11', false) && /explorer/.test(Browser.browserVersionStr)
      track("Unsupported Browser Banner", "Displayed", Browser.browserVersionStr)
      container.append(@topLevelView(BrowserWillBeUnsupportedView, me, modelCache: headerCache).render().el)

    # See if there are any important messages we'd like to convey to the user
    if @currentModel.get()? && Util.hasValidInviteTokenFor(@currentModel.get())
      opts = { modelCache: @getCurrentModelCache() }
      if @onAnyBoardView()
        opts.idBoard = @currentModel.get().id
      else if @onAnyOrganizationView()
        opts.idOrganization = @currentModel.get().id
      opts.idMemberAdder = Util.inviteTokenFor(@currentModel.get().id).split('-')[1]
      container.append(@topLevelView(InvitedBannerView, me, opts, @currentModel.get().id).render().el)
        .toggleClass('personalized-invite', !Auth.isLoggedIn())
    else
      if Auth.isLoggedIn()
        # Show logged in public board banner, even if another banner is showing,
        # but defer to view for watching if board is public. This handles the case
        # when a board is private but becomes public.
        if @onAnyBoardView()
          container.append(@topLevelView(LoggedInPublicBoardBannerView, @currentModel.get(), modelCache: @getCurrentModelCache()).render().el)
          downgradeBanner = @topLevelView(DowngradePeriodBannerView, @currentModel.get(), modelCache: @getCurrentModelCache()).render()
          container.append(downgradeBanner.el)
          if !downgradeBanner.isShown()
            container.append(@topLevelView(BoardLimitsGracePeriodBannerView, @currentModel.get(), modelCache: @getCurrentModelCache()).render().el)


        if !Auth.confirmed()
          container.append(@topLevelView(ConfirmEmailBannerView, me, modelCache: headerCache).render().el)
        else if !Auth.canLogIn()
          container.append(@topLevelView(SetPasswordBannerView, me, modelCache: headerCache).render().el)
        else if Auth.me().needsToBecomeAaMastered() && !AaDomainClaimBannerView::isSnoozed()
          container.append(
            @topLevelView(AaDomainClaimBannerView, me,
              enterprise: Auth.me().getEnterprise()
              onChange: => @showHeader()
            ).render().el
          )
        else if ((enterprise = Auth.me().enterpriseWithRequiredConversion()) && !me.isAccountTransferBannerDismissed())
          opts =
            modelCache: headerCache
            locale: locale
            enterprise: enterprise
          container.append(@topLevelView(AccountTransferRequiredBannerView, me, opts).render().el)
        else if (org = getOverdueOrganization(Auth.me()))
          container.append(@topLevelView(OverdueBannerView, org, modelCache: headerCache).render().el)
        else if needBackupCodes(Auth.me())
          container.append(@topLevelView(TwoFactorBackupsBannerView, me, modelCache: headerCache).render().el)
        else if (locale = _.find(bannerLocales, (locale) -> Auth.me().shouldShowNewLanguageBannerFor(locale)))
          container.append(@topLevelView(NewLocaleBannerView, me, { modelCache: headerCache, locale: locale }).render().el)

        # always try to add the seat cap banner, even if another banner is showing
        showSeatCapBanner(Auth.me(), headerCache, @topLevelView.bind(@))
      else
        if @onAnyBoardView() && @currentModel.get().isPublic()
          container.append(@topLevelView(PublicBoardBannerView, @currentModel.get(), modelCache: @getCurrentModelCache()).render().el)

  renderClassicHeader: (opts) ->
    me = Auth.me()
    headerCache = ModelCache

    $('#header .header-user').remove()
    $('#header .header-boards-button').remove()
    $('#header #header-search').parent().remove()
    $('#header-search').empty()
    $('.header-banner').remove()
    $('#header nav').remove()

    if Browser.isEmbeddedDocument()
      if @onAnyBoardView()
        # We won't show the header if the board is embedded.
        $('#header').hide()
      else
        # We only need the logo if Trello is embedded.
        $('#header').empty().prepend templates.fill('header_logo')
        $('#header').show()
      return

    $('#header').empty().prepend templates.fill('header_logo')

    if opts.promo || !Auth.isLoggedIn()
      $('#header').append(templates.fill('header_promo_nav'))
    else

      $('#header').append(@topLevelView(HeaderBackButtonView, me, modelCache: headerCache).render().el)
      $('#header').append(@topLevelView(HeaderBoardsButtonView, me, modelCache: headerCache).render().el)
      if !opts.noSearch then $('#header').append(@topLevelView(SearchInputView, me, modelCache: headerCache).render().el)
      $('#header .header-woof').parent().remove()
      $('#header').append(@topLevelView(HeaderWoofView, me, modelCache: headerCache).render().el)

      renderBoardsDrawer = =>
        if !@_boardDrawerRendered
          @_boardDrawerRendered = true
          $('#boards-drawer')
          .empty()
          .append(new BoardsSidebarView({ model: me, modelCache: headerCache }).render().el)

      if SidebarState.getPinSidebar()
        renderBoardsDrawer()
      else
        # If the user doesn't have the sidebar pinned open, we can defer rendering it
        PostRender.enqueue 'render_boards_drawer', renderBoardsDrawer

    $('#header').append(@topLevelView(HeaderMemberView, me, { modelCache: headerCache, currentModel: @currentModel.get() }).render(opts.promo).el)

  showHeader: (opts = {}) ->
    isGammaHeader = getExperiment('gammaHeader').get('enabled')
    me = Auth.me()

    # Existing Classic header implementation
    if !isGammaHeader
      this.renderClassicHeader(opts)

    this.renderBannerContent()

    me.checkColorBlindMode()
    return



// WEBPACK FOOTER //
// ./app/scripts/controller/header.coffee